import {Command} from '@application/command/command';
import {ProductionSchedule} from '@domain/production-schedule/production-schedule';
import {ParametersForUpdatingDrawingsAndOrderLinesOfProductionSchedule} from '@presentation/pages/texfab/production-schedule/add/plan/parameters-for-updating-drawings-and-order-lines-of-production-schedule';

export class UpdateDrawingsAndOrderLinesOfProductionScheduleCommand implements Command<ParametersForUpdatingDrawingsAndOrderLinesOfProductionSchedule, ProductionSchedule> {
  public execute(commandArgs: ParametersForUpdatingDrawingsAndOrderLinesOfProductionSchedule): ProductionSchedule {
    const {productionSchedule, drawings, orderLines} = commandArgs;
    productionSchedule.designs = drawings;
    productionSchedule.orderLines = orderLines;
    return productionSchedule;
  }
}
